import * as React from 'react';
import Modal from '../../misc/components/modal';
import { User } from '../../misc/api/apiTypes';
import Loading from '../../misc/components/loading';
import Alert, { AlertCategoryEnum } from '../../misc/components/Alert';
import { PermissionEnum } from '../../misc/api/ApiPermissionEnum';
import { useCurrentStudyConfigurationContext } from '../../Core/CurrentStudyConfigurationContext';
import { CoughAnalysisSet, WebPortalClient } from 'webportalclient';
import { useWebPortalLegacyClient } from '../../misc/api/WebPortalTokenClient';

export interface AssignToUserModalProps {
    analysisSet: CoughAnalysisSet;
    onClose: () => void;
}

declare const rootUrl;

export const AssignToUserModal = (props: AssignToUserModalProps) => {
    const [error, setError] = React.useState<string | undefined>();
    const [submitting, setSubmitting] = React.useState(false);
    const { study } = useCurrentStudyConfigurationContext();

    const [users, setUsers] = React.useState<User[]>();
    const [selectedUser, setSelectedUser] = React.useState<string>();
    const legacyClient = useWebPortalLegacyClient();

    React.useEffect(() => {
        const getUsers = async () => {
            legacyClient.getUsersByPermissionIncludingAllStudies(study.id, PermissionEnum.OpenAssignedCoughAnalysisSets)
                .then((usersResult) => {
                    if (usersResult.length === 0) {
                        setError("There are no users present with the 'Open Assigned Cough Analysis Sets' permission");
                    }

                    setUsers(usersResult.sort((a, b) => a.Username > b.Username ? 1 : -1));
                });
        }

        getUsers();
    }, []);

    const assignToUser = (analysisSetId: string, userId: string) => {
        setSubmitting(true);

        legacyClient.assignToUser(analysisSetId, userId)
            .then(json => {
                setSubmitting(false);
                props.onClose();
            });
    }

    const renderQATypesSelect = () => {
        if (users) {
            return (<select className="form-control" value={selectedUser} onChange={e => setSelectedUser(e.target.value)}>
                <option></option>
                {users.map(i =>
                    <option key={i.Id} value={i.Id}>{i.Username}</option>
                )}
            </select>);
        } else if (error) {
            return <Alert show={true} category={AlertCategoryEnum.Danger}>{error}</Alert>;
        } else if (submitting) {
            return <Loading />;
        } else {
            return null;
        }
    }

    return (<Modal show={true} closeModalHandler={() => props.onClose()} header="Assign to Analyst">
        <div className='modal-body'>
            {renderQATypesSelect()}
        </div>
        <div className='modal-footer'>
            <button disabled={submitting} className='btn btn-primary' onClick={() => assignToUser(props.analysisSet.id, selectedUser)}>Assign</button>
            <button className='btn btn-outline btn-primary' onClick={() => props.onClose()}>Close</button>
        </div>
    </Modal>);
}
